import { processDate } from '@/helpers/utils';
import {
  checkLength,
  checkRequired,
} from '@/helpers/utils/functionality-utils';
import { zarr, zcusn, zdaten, zobj, zstr } from '@/helpers/zodLib';
import type { CarrierMaster, CustomerInterface } from '@/types/carrier-types';
import type { AddTaskRequestInterface } from '@/types/user/task-types';
import type { User } from '@/types/userlist';
import z from 'zod';

export const AddTaskSchema = zobj({
  assignTo: zarr(zcusn<User>()),
  description: zstr,
  dueDate: zdaten,
  moreInfo: z.record(zstr, zstr),
  customer: zcusn<CustomerInterface>(),
  carrier: zcusn<CarrierMaster>(),
}).superRefine((data, ctx) => {
  if (!data.assignTo) {
    checkRequired(data.assignTo, 'assignTo', ctx);
  }
  if (!data.description) {
    checkRequired(data.description, 'description', ctx);
  }
  if (data?.description) {
    checkLength(data.description, 'description', ctx, 5, 300);
  }
  if (!data.dueDate) {
    checkRequired(data.dueDate, 'dueDate', ctx);
  }
});

export type AddTaskSchemaType = z.infer<typeof AddTaskSchema>;

export const AddTaskInitialValues: AddTaskSchemaType = {
  assignTo: [],
  description: '',
  dueDate: new Date(),
  moreInfo: {},
  customer: null,
  carrier: null,
};

export function generateAddTaskPayload(data: AddTaskSchemaType, id: number) {
  const moreInfo: Record<string, string> = {};
  if (data.carrier) {
    moreInfo.carrier_id = String(data.carrier.carrier_id);
    moreInfo.stock_no = data.carrier.stock_no;
  }
  if (data.customer) {
    moreInfo.cust_id = String(data.customer.id);
    moreInfo.cust_name = data.customer.name;
  }
  const payload: AddTaskRequestInterface = {
    assigned_to: id,
    description: data.description,
    due_date: data?.dueDate
      ? processDate(data.dueDate.toISOString(), 'api').formattedDate || ''
      : '',
    more_info: moreInfo,
  };
  return payload;
}
